import { useSettings } from "../../lib/settings";

const Row = ({ words, hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {words.map((w, i) => (
      <span key={i} className="flex items-center">
        <span className={`f-display px-8 sm:px-12 text-5xl sm:text-7xl lg:text-8xl font-light ${i % 2 ? "italic text-[#C9A15A]" : "text-[#F6F1E9]"}`}>{w}</span>
        <span className="text-[#C9A15A] text-2xl">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { settings } = useSettings();
  const words = settings.marquee.length < 4 ? [...settings.marquee, ...settings.marquee, ...settings.marquee] : settings.marquee;
  return (
  <section className="bg-[#15202B] py-10 sm:py-14 overflow-hidden" data-testid="editorial-marquee" aria-label="Techniques de l'artiste">
    <div className="flex w-max marquee-track">
      <Row words={words} /><Row words={words} hidden />
    </div>
  </section>
  );
};
